import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';

import ClearAllFiltersButton from './ClearAllFiltersButton';
import FiltersSetsDropdown from './FiltersSetsDropdown';
import NewFilterSetButton from './NewFilterSetButton';
import RemoveActiveFilterSetButton from './RemoveActiveFilterSetButton';
import SaveActiveFilterSetButton from './SaveActiveFilterSetButton';

const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 7px;
`;

const FormGroup = styled(Space.Compact)`
  display: flex;
`;

const Title = styled.span`
  margin-right: 13px;
`;

function FiltersDrawerHeader() {
  return (
    <Container>
      <Title>Edit Filter</Title>

      <FormGroup>
        <FiltersSetsDropdown />
        <NewFilterSetButton />
        <SaveActiveFilterSetButton />
        <RemoveActiveFilterSetButton />
      </FormGroup>

      <ClearAllFiltersButton />
    </Container>
  );
}

export default FiltersDrawerHeader;
